import { render, staticRenderFns } from "./BlkSidebar.vue?vue&type=template&id=38e820ef&"
import script from "./BlkSidebar.vue?vue&type=script&lang=ts&"
export * from "./BlkSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./BlkSidebar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports